import { render, staticRenderFns } from "./OnboardingUserInfo.vue?vue&type=template&id=13988a52&"
import script from "./OnboardingUserInfo.vue?vue&type=script&lang=ts&"
export * from "./OnboardingUserInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports